"use client";

import { useEffect } from "react";

export default function WebVitalsTracker() {
  useEffect(() => {
    // Dynamically import web vitals to avoid SSR issues
    const initWebVitals = async () => {
      try {
        const { default: initializeWebVitals } = await import(
          "../lib/webVitals"
        );
        initializeWebVitals();
      } catch (error) {
        console.warn("[Web Vitals] Failed to initialize:", error);
      }
    };

    // Initialize after a short delay to ensure page is fully loaded
    const timer = setTimeout(initWebVitals, 100);

    return () => clearTimeout(timer);
  }, []);

  // This component doesn't render anything
  return null;
}
